import * as React from 'react';
import { Spin } from 'antd';
import MLModel from '../../../ml_models/models/MLModel';
import { SelectWhenScroll } from '../SelectWhenScroll';

interface SmartBlockConfigProps {
    modelId: string;
    models: MLModel[];
    isLoadingModels: boolean;
    disabled: boolean;
    onModelChange: (modelId: string) => void;
}

const SmartBlockConfig: React.FC<SmartBlockConfigProps> = ({
    modelId,
    models,
    isLoadingModels,
    disabled,
    onModelChange
}) => {
    const modelOptions = React.useMemo(() => {
        return models.map(model => ({
            label: model.name,
            value: model.id || ''
        }));
    }, [models]);

    return (
        <div className="custom-block-field">
            <label className="custom-block-label">Model</label>
            <SelectWhenScroll
                value={modelId}
                onChange={onModelChange}
                options={modelOptions}
                disabled={disabled || isLoadingModels}
                loading={isLoadingModels}
                notFoundContent={isLoadingModels ? <Spin size="small" /> : 'No models found'}
                showSearch
                optionFilterProp="label"
                placeholder="Select a model"
                style={{ width: '100%' }}
            />
        </div>
    );
};

export default SmartBlockConfig;
